import { makeStyles } from "@material-ui/core";
import { FieldConfig, useField, useFormikContext } from "formik";
import { t } from "i18next";
import React from "react";
import ReactDatePicker from "react-datepicker";

interface Props extends FieldConfig {
  label?: string;
  dir?: string;
  placeholder?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  periodlevelId?: string;
  setVisiblePeriods?: (
    periodlevelId: string,
    startDate: string,
    endDate: string
  ) => void;
  isStartDate?: boolean;
  currentStartDate?: string;
  currentEndDate?: string;
}

const useStyles = (error: boolean) =>
  makeStyles({
    container: { display: "flex", flexDirection: "column", width: "100%" },
    label: {
      fontFamily: "Dubai",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#374151",
    },
    datePicker: {
      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      borderRadius: "6px",
      border: `1px solid ${error ? "red" : "#D1D5DB"}`,
      padding: "0 15px",
      height: "38px",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "20px",
      width: "100%",
    },
    "react-datepicker-popper": {
      zIndex: 4,
    },
  });

const DatePicker = (props: Props) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);
  const classes = useStyles(Boolean(meta.touched && meta.error))();
  return (
    <div className={classes.container}>
      <p className={classes.label}>{props.label}</p>
      <div className={classes.container}>
        <ReactDatePicker
          className={classes.datePicker}
          {...field}
          {...props}
          placeholderText={props.placeholder}
          selected={field.value}
          dateFormat={"dd/MM/yyyy"}
          onChange={(value: any) => {
            if (value === null) {
              setFieldValue(field.name, null);
              return;
            }
            const UTCDate = Date.UTC(
              value.getFullYear(),
              value.getMonth(),
              value.getDate()
            );
            const fixedDate = new Date(UTCDate);
            const year = fixedDate.getUTCFullYear();
            const month = ("0" + (fixedDate.getMonth() + 1)).slice(-2);
            const day = ("0" + fixedDate.getUTCDate()).slice(-2);
            const newDate = `${year}-${month}-${day}`;
            if (props.setVisiblePeriods && props.periodlevelId) {
              const startDate = props.isStartDate
                ? newDate
                : props.currentStartDate;
              const endDate =
                props.isStartDate === false ? newDate : props.currentEndDate;
              props.setVisiblePeriods(
                props.periodlevelId,
                startDate || "",
                endDate || ""
              );
            }
            setFieldValue(field.name, newDate);
          }}
          portalId="root-portal"
        />
      </div>
      <p
        style={{
          color: "RED",
          fontSize: "14px",
          marginInlineStart: "16px",
          marginTop: "8px",
        }}
      >
        {" "}
        {meta.touched && !!meta.error && t(meta.error)}
      </p>
    </div>
  );
};

export default DatePicker;
